export const types: {[platform: string]: string} = {
  Facebook: 'Facebook',
  Instagram: 'Instagram',
};
